// The headings a client sees estate items under, in order, for each direction
export const ESTATE_ITEM_GROUPS = {
  asset: [
    { key: "property", title: "Property and land" },
    { key: "accounts", title: "Bank and building society accounts" },
    { key: "cash", title: "Cash" },
    { key: "investments", title: "Shares and investments" },
    { key: "pensions", title: "Pensions" },
    { key: "insurance", title: "Life insurance" },
    { key: "vehicles", title: "Vehicles" },
    { key: "belongings", title: "Belongings and valuables" },
    { key: "business", title: "Business interests" },
    { key: "owedToThem", title: "Money owed to them" },
    { key: "otherAssets", title: "Other things they owned" },
  ],
  liability: [
    { key: "mortgages", title: "Mortgages" },
    { key: "cards", title: "Credit cards" },
    { key: "loans", title: "Loans and overdrafts" },
    { key: "bills", title: "Unpaid bills" },
    { key: "tax", title: "Tax" },
    { key: "funeral", title: "Funeral costs" },
    { key: "fees", title: "Our fees" },
    { key: "otherDebts", title: "Other debts" },
  ],
};

// Keyed by EstateItemType in webapp-alpha (app/common/global_models/probate/estate_types.py)
export const GROUP_OF_TYPE = {
  property_or_land: "property",
  bank_account: "accounts",
  cash: "cash",
  shares_and_investments: "investments",
  pension: "pensions",
  life_insurance: "insurance",
  vehicle: "vehicles",
  household_goods: "belongings",
  business_interest: "business",
  money_owed_to_deceased: "owedToThem",
  other_asset: "otherAssets",
  mortgage: "mortgages",
  credit_card: "cards",
  loan: "loans",
  overdraft: "loans",
  arrears: "bills",
  tax_owed: "tax",
  inheritance_tax: "tax",
  funeral_costs: "funeral",
  juno_fee: "fees",
  discovery_fee: "fees",
  other_liability: "otherDebts",
};

// The group for an item type that GROUP_OF_TYPE doesn't list yet
export const OTHER_GROUP = { asset: "otherAssets", liability: "otherDebts" };
